import pluralize from 'pluralize';

pluralize.addIrregularRule('trouvé', 'trouvés');
pluralize.addIrregularRule('cannal', 'cannaux');

export default pluralize;
